<div class="custom-snackbar">
  <mat-icon *ngIf="type === 'INFO'" aria-hidden="false" aria-label="info" class="icon-info">info</mat-icon>
  <mat-icon *ngIf="type === 'ERROR'"  aria-hidden="false" aria-label="error" class="icon-error">error</mat-icon>
  <mat-icon *ngIf="type === 'WARNING'" aria-hidden="false" aria-label="warning" class="icon-warn">warning</mat-icon>
  <mat-icon *ngIf="type === 'SUCCESS'" aria-hidden="false" aria-label="success" class="icon-success">check_circle</mat-icon>
  <div>{{ data.message }}</div>
</div>
